// extracted by mini-css-extract-plugin
export var addressFields = "_jn-0";
export var animationContainer = "_jn-1";
export var footer = "_jn-2";
export var lineItems = "_jn-3";
export var modalContent = "_jn-4";
export var orderName = "_jn-5";
export var strong = "_jn-6";
export var warning = "_jn-7";